module.exports = __webpack_public_path__ + "media/images/contact_phone-ca93468063be0ad19a54bb4f7b0fe39a.png";